import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { PaymentProvider } from '../models/payment-provider';
import { PaymentService } from './payment.service';
import { GiftCard } from '../../giftcard/models/giftcard';
import { DiscountCoupon } from '../models/discount-coupon';
import { PrepaidPaymentInfo } from '../models/prepaid-payment-info';
import { ShopSettingsService } from '../../general/services/shop-settings.service';
import { PaymentVuService } from './payment-vu.service';
import { PaymentOdooService } from './payment-odoo.service';

@Injectable()
export class PaymentProxyService implements PaymentService {

  private _paymentService: PaymentService;

  constructor(
    private injector: Injector,
    private shopSettingsService: ShopSettingsService
  ) {
  }

  get paymentService(): PaymentService {
    if (this._paymentService) {
      if (
        (this._paymentService instanceof PaymentVuService && this.shopSettingsService.isVUMode) ||
        (this._paymentService instanceof PaymentOdooService && !this.shopSettingsService.isVUMode)) {
        return this._paymentService;
      }
    }

    if (this.shopSettingsService.isVUMode) {
      this._paymentService = this.injector.get(PaymentVuService);
    } else {
      this._paymentService = this.injector.get(PaymentOdooService);
    }

    return this._paymentService;
  }

  paymentTransaction(orderId: number, paymentProviderId: number): Observable<string> {
    return this.paymentService.paymentTransaction(orderId, paymentProviderId);
  }

  paymentGuestTransaction(orderId: number,  guestOrderKey: string, paymentProviderId: number): Observable<string> {
    return this.paymentService.paymentGuestTransaction(orderId,  guestOrderKey, paymentProviderId);
  }

  payOrderByGiftCard(orderId: number): Observable<boolean> {
    return this.paymentService.payOrderByGiftCard(orderId);
  }

  guestPayOrderByGiftCard(orderId: number): Observable<string> {
    return this.paymentService.guestPayOrderByGiftCard(orderId);
  }

  payOrderByCash(orderId: number): Observable<boolean> {
    return this.paymentService.payOrderByCash(orderId);
  }

  getPaymentProviders(): Observable<PaymentProvider[]> {
    return this.paymentService.getPaymentProviders();
  }

  prepaidOrder(orderNumber: number, giftCardRedeems: GiftCard[], discountCoupon: DiscountCoupon[]): Observable<PrepaidPaymentInfo> {
    return this.paymentService.prepaidOrder(orderNumber, giftCardRedeems, discountCoupon);
  }

  prepaidGuestOrder(orderNumber: number, giftCardRedeems: GiftCard[], discountCoupon: DiscountCoupon[]): Observable<PrepaidPaymentInfo> {
    return this.paymentService.prepaidGuestOrder(orderNumber, giftCardRedeems, discountCoupon);
  }
}
